"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERSECTION = void 0;
var INTERSECTION = {
  OUTSIDE: -1,
  INTERSECTING: 0,
  INSIDE: 1
};
exports.INTERSECTION = INTERSECTION;
//# sourceMappingURL=constants.js.map